export class VendorSearchDTO{
  public business_name?:string
  public vendor_code?:string
  public status?:string
  public creation_date?:string
  public is_black_list?:string
  public is_legal_case?:string
  public black_list_remark?:string
  public reject_reason?:string
  public pan_no?:string
  public select_industry_type?:string
  public payment_term?:string
  public new_account_group?:string
  public purchase_organization?:string
}

export class AddressSearchDTO{
  public address_title?:string
  public city?:string
  public state?:string
  public country?:string
}
export class GstinSearchDTO{
  public gstn?:string
}


